import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {

  constructor(@Inject(DOCUMENT) private document: Document) {}

  /**
   * Determines the language/locale from the current URL path.
   * @returns The language code extracted from the URL, defaults to 'en'.
   */
  getLanguageFromUrl(): string {
    const url = this.document.URL.toLowerCase();
    return url.includes('/en/') ? 'en'
               : url.includes('/en-us/') ? 'en-us'
               : url.includes('/fr-fr/') ? 'fr-fr'
               : url.includes('/en-mx/') ? 'en-mx'
               : url.includes('/es-mx/') ? 'es-mx'
               : 'en-us'; // Default to 'en-us' if no specific language is found
  }
}
